export const PROGRAM_ITEM_REGULATION_SLUG_SEPARATOR = '_item_reg_'
const LEGACY_PROGRAM_ITEM_REGULATION_SLUG_SEPARATOR = '__reg__'

function normalizeProgramItemIdForSlug(programItemId: string): string {
  return programItemId
    .trim()
    .toLowerCase()
    .replace(/-/g, '_')
    .replace(/[^a-z0-9_]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')
}

export function buildProgramItemRegulationModuleSlug(
  programModuleSlug: string,
  programItemId: string,
): string {
  return `${programModuleSlug}${PROGRAM_ITEM_REGULATION_SLUG_SEPARATOR}${normalizeProgramItemIdForSlug(programItemId)}`
}

export function normalizeProgramItemRegulationModuleSlug(
  slug: string | null | undefined,
): string {
  if (!slug) {
    return ''
  }

  if (slug.includes(PROGRAM_ITEM_REGULATION_SLUG_SEPARATOR)) {
    return slug
  }

  const legacySeparatorIndex = slug.indexOf(LEGACY_PROGRAM_ITEM_REGULATION_SLUG_SEPARATOR)
  if (legacySeparatorIndex < 0) {
    return slug
  }

  const programModuleSlug = slug.slice(0, legacySeparatorIndex)
  const programItemId = slug.slice(
    legacySeparatorIndex + LEGACY_PROGRAM_ITEM_REGULATION_SLUG_SEPARATOR.length,
  )

  if (!programModuleSlug || !programItemId) {
    return slug
  }

  return buildProgramItemRegulationModuleSlug(programModuleSlug, programItemId)
}

export function isProgramItemRegulationModuleSlug(slug: string | null | undefined): boolean {
  if (!slug) {
    return false
  }
  return slug.includes(PROGRAM_ITEM_REGULATION_SLUG_SEPARATOR)
    || slug.includes(LEGACY_PROGRAM_ITEM_REGULATION_SLUG_SEPARATOR)
}

export function parseProgramItemRegulationModuleSlug(
  slug: string,
): { programModuleSlug: string, programItemId: string } | null {
  const separatorIndex = slug.indexOf(PROGRAM_ITEM_REGULATION_SLUG_SEPARATOR)
  if (separatorIndex < 0) {
    return null
  }

  const programModuleSlug = slug.slice(0, separatorIndex)
  const programItemId = slug.slice(
    separatorIndex + PROGRAM_ITEM_REGULATION_SLUG_SEPARATOR.length,
  )

  if (!programModuleSlug || !programItemId) {
    return null
  }

  return { programModuleSlug, programItemId }
}
